import type { CSSProperties } from 'react';

export const headerStyle: CSSProperties = {
  height: 56,
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  padding: '0 16px',
  borderBottom: '1px solid var(--color-border-soft)',
  background: 'color-mix(in srgb, var(--color-bg) 70%, transparent)',
  backdropFilter: 'blur(20px)',
  position: 'sticky',
  top: 0,
  zIndex: 10,
};

export const breadcrumbStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  color: 'var(--color-text-dim)',
  fontSize: 13,
};

export const centerStyle: CSSProperties = {
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  minWidth: 0,
};
